<template>
  <f7-page class="main-expedition-document-add-pale-no-sales">
    <template #fixed>
      <TheNavbar
        v-if="lineSelected != null"
        :nav-title="`${lineSelected.Expedicion.Serie} / ${lineSelected.Expedicion.Numero}`"
        :back-btn-enable="true"
        :back-callback="goBack"
        :style="appTheme"
      >
        <template #right>
          <div
            v-if="expedition.EstadoOrdenCarga !== 2"
            class="display-flex"
          >
            <f7-link
              icon="icon-delete"
              @click="EventDeleteLine"
            />
            <f7-link
              @click="EventOpenReadAnsForCarga"
            >
              <img :src="icQr">
            </f7-link>
          </div>
        </template>
      </TheNavbar>
    </template>

    <div
      v-if="lineSelected != null"
      class="content-data padding"
    >
      <div class="content-data__row">
        <div class="content-data__col">
          <div class="content-data__col--gray">
            {{ $t('common.customer') }}
          </div>
          <div
            v-if="lineSelected.Cliente != null"
            class="content-data__col--strong-blue"
          >
            <!-- <pre>{{ lineSelected }}</pre> -->
            {{ lineSelected.Cliente.Nombre }}
          </div>
        </div>
        <div class="content-data__info">
          <div
            v-if="lineSelected.Cliente != null"
            class="content-data__info--strong-blue"
          >
            {{ lineSelected.CantidadTotalCargada }} <span>{{ $t('common.of') }}</span> {{ lineSelected.CantidadTotalPales }}
          </div>
          <img :src="icPalet">
        </div>
      </div>
      <div class="content-data__row margin-top-half">
        <div class="content-data__col">
          <div class="content-data__col--gray">
            {{ $t('common.product') }}
          </div>
          <div
            v-if="lineSelected.Producto != null"
            class="content-data__col--strong-blue"
          >
            {{ lineSelected.Producto.Nombre }}
          </div>
        </div>
      </div>
      <div class="content-data__row margin-top-half">
        <div
          v-if="lineSelected.Marca != null"
          class="content-data__col"
        >
          <div class="content-data__col--gray">
            {{ $t('common.brand') }}
          </div>
          <div
            class="content-data__col--strong-blue"
          >
            {{ lineSelected.Marca.Nombre }}
          </div>
        </div>
        <div class="content-data__col">
          <div class="content-data__col--gray">
            {{ $t('common.format') }}
          </div>
          <div
            v-if="lineSelected.Envase != null"
            class="content-data__col--strong-blue"
          >
            {{ lineSelected.Envase.Nombre }}
          </div>
        </div>
      </div>
    </div>
    <!--- Palets Cargados -->
    <f7-block class="content-data no-padding">
      <UCAcordeon
        title-option="Estado"
        font-color="#FFFFFF"
        title-sub-option="Orden"
        :items="paletsCargados"
        :closed="false"
        :show-badge="false"
        :show-checkbox="expedition.EstadoOrdenCarga !== 2 ? true : false"
        checkbox-row-title="Todos"
        :after-title="false"
        :disabled-btn-options-no-items-selected="true"
        @open-options="(expedition.EstadoOrdenCarga !== 2) ? actionChargesOpened = true : actionChargesOpened = false"
      >
        <template #subOptionSubtitle="{ item }">
          <f7-list
            media-list
            :class="filtradoPorNumeroSerie === item.UnidadContenedora.NumeroSerie ? 'suboption-list-fondo' : 'suboption-list'"
          >
            <f7-list-item>
              <template #title>
                <div
                  style="display: flex;
                          align-items: center;
                          justify-content: space-between;
                          padding-right: 20px;"
                >
                  {{ item.UnidadContenedora.NumeroSerie }}
                  <span
                    v-if="item.UnidadContenedora.Mixta"
                    class="suboption-list__mix"
                  > {{ $t('commercialization.common.mixedPallet') }} </span>
                </div>
              </template>

              <template #footer>
                <div v-if="!item.disabled">
                  {{ `${$t('commercialization.common.palletTemperature')} ${item.TemperaturaPale}°C` }}
                </div>

                <div v-if="item.disabled">
                  {{ $t('commercialization.common.loadedFromAnotherLine') }}
                </div>
              </template>

              <template #after>
                <div>
                  {{ item.UnidadContenedora.CantidadEnvases }}
                </div>
              </template>
            </f7-list-item>
          </f7-list>
        </template>
      </UCAcordeon>
      <UCAcordeon
        title-option="Estado"
        primary="#979797"
        font-color="#FFFFFF"
        title-sub-option="Orden"
        :items="paletsReservados"
        :closed="false"
        :show-badge="false"
        :show-checkbox="expedition.EstadoOrdenCarga !== 2 ? true : false"
        checkbox-row-title="Todos"
        :after-title="false"
        :disabled-btn-options-no-items-selected="false"
        @open-options="(expedition.EstadoOrdenCarga !== 2) ? EventOpenActionsReservation(true) : EventOpenActionsReservation(false)"
      >
        <template #subOptionSubtitle="{ item }">
          <f7-list
            media-list
            class="suboption-list"
          >
            <f7-list-item>
              <template #title>
                <div
                  style="display: flex;
                          align-items: center;
                          justify-content: space-between;
                          "
                >
                  {{ item.UnidadContenedora.NumeroSerie }}
                  <span
                    v-if="item.UnidadContenedora.Mixta"
                    class="suboption-list__mix"
                  > {{ $t('commercialization.common.mixedPallet') }} </span>
                </div>
              </template>

              <template #subtitle>
                <div>
                  {{ item.UnidadContenedora.Ubicacion?.Nombre ?? $t('common.locationUnknown') }}
                </div>
              </template>

              <template #footer>
                <div v-if="!item.disabled">
                  {{ `${$t('commercialization.common.palletTemperature')} ${item.TemperaturaPale}°C` }}
                </div>
                <div v-if="item.disabled">
                  {{ $t('commercialization.common.reservedFromAnotherLine') }}
                </div>
              </template>

              <template #after>
                <div>
                  {{ item.UnidadContenedora.CantidadEnvases }}
                </div>
              </template>
            </f7-list-item>
          </f7-list>
        </template>
      </UCAcordeon>
    </f7-block>

    <!-- ACTION DEL FORMULARIO -->
    <div>
      <!-- Action sobre Pales CARGADOS. -->
      <f7-actions
        class="content-action"
        :grid="true"
        :opened="actionChargesOpened"
        @actions:closed="actionChargesOpened = false"
      >
        <f7-actions-group>
          <f7-actions-label>{{ $t('common.whatDoYouWantToDo') }}</f7-actions-label>
          <div class="content-action__buttons">
            <f7-actions-button class="content-action__buttons--red">
              <template #media>
                <img
                  src="@/static/icons/ic_delete.svg"
                  width="50"
                  class="img-delete"
                  @click="DeleteCharge()"
                >
              </template>
              <span>{{ $t('commercialization.common.deleteLoad') }}</span>
            </f7-actions-button>
            <f7-actions-button
              class="content-action__buttons--green"
            >
              <template #media>
                <img
                  src="@/static/img/ic_button_edit.svg"
                  width="50"
                  class="img-delete"
                  @click="actionReservationOpened = false; actionAddTemperature = true ; itemSelected = 0"
                >
              </template>
              <span>{{ $t('commercialization.common.changeTemperature') }}</span>
            </f7-actions-button>
          </div>
        </f7-actions-group>
      </f7-actions>
      <!-- Action sobre Pales RESERVADOS ORDEN DE CARGA -->
      <f7-actions
        class="content-action"
        :grid="true"
        :opened="actionReservationOpened"
        @actions:closed="actionReservationOpened = false"
      >
        <f7-actions-group>
          <f7-actions-label>{{ $t('common.whatDoYouWantToDo') }}</f7-actions-label>
          <div class="content-action__buttons">
            <f7-actions-button
              v-if="showOptionDeleteReservation"
              class="content-action__buttons--red"
            >
              <template #media>
                <img
                  src="@/static/icons/ic_delete.svg"
                  width="50"
                  class="img-delete"
                  @click="DeleteReservationSelected()"
                >
              </template>
              <span>{{ $t('commercialization.common.deleteReservation ') }}</span>
            </f7-actions-button>
            <f7-actions-button
              v-if="showOptionChargeReservation"
              class="content-action__buttons--green"
            >
              <template #media>
                <img
                  src="@/static/icons/ic_addGreen.svg"
                  width="50"
                  class="img-delete"
                  @click="ChargeSelectedPales()"
                >
              </template>
              <span>{{ $t('commercialization.common.loadPallet') }}</span>
            </f7-actions-button>
            <f7-actions-button
              v-if="showOptionChargeReservation"
              class="content-action__buttons--green"
            >
              <template #media>
                <img

                  src="@/static/img/ic_button_edit.svg"
                  width="50"
                  class="img-delete"
                  @click="actionReservationOpened = false; actionAddTemperature = true; itemSelected = 1 "
                >
              </template>
              <span>{{ $t('commercialization.common.changeTemperature') }}</span>
            </f7-actions-button>
            <f7-actions-button
              v-if="!showOptionChargeReservation && !showOptionDeleteReservation"
              class="content-action__buttons--gray"
            >
              <template #media>
                <img
                  src="@/static/icons/ic_qr.svg"
                  width="50"
                  class="img-add"
                  @click="EventOpenReadAnsForReservation()"
                >
              </template>
              <span>{{ $t('commercialization.common.addNewPalletReservation') }}</span>
            </f7-actions-button>
          </div>
        </f7-actions-group>
      </f7-actions>
      <f7-actions
        class="content-action"
        :grid="true"
        :opened="actionAddTemperature"
        @actions:closed="actionAddTemperature = false"
      >
        <f7-actions-group>
          <f7-actions-label>{{ $t('commercialization.common.enterPalletTemperature') }}</f7-actions-label>
          <div class="input-temperatura">
            <f7-input
              outline
              style="padding-bottom: 10px;padding-top: 10px;"
              type="number"
              step=".001"
              placeholder="Temperatura Palé"
              clear-button
              @input="temperatura = $event.target.value"
            />
          </div>
          <div class="content-action__buttons">
            <f7-actions-button
              class="actions-button--cancelar"
              @click="actionAddTemperature = false"
            >
              {{ $t('common.cancel') }}
            </f7-actions-button>
            <f7-actions-button
              class="actions-button--guardar"
              bold
              @click="(itemSelected === 0) ? ChangeTemperaturePaletsSelectedCargados() : ChangeTemperaturePaletsSelectedReservados()"
            >
              {{ $t('common.save') }}
            </f7-actions-button>
          </div>
        </f7-actions-group>
      </f7-actions>
    </div>

    <UCCodeScanner
      ref="UCCodeScannerNotifyAddPale"
      :continuous-bar-code-reading="true"
      :allow-manual-code-entry="true"
      :fab-button-show="false"
      :open-information-bar="infoSheetParams.opened"
      :title="infoSheetParams.title"
      :subtitle1="infoSheetParams.subtitle1"
      :state="infoSheetParams.state"
      @code-reading="EventBarCodeReading"
      @popup-close="EventScannerCamClose"
      @codigo-barras="EventBarCodeReading"
      @numero-serie="EventNumeroSerieReading"
    >
      <template #slotShowInfo>
        <div>
          <div class="quantityCharged padding-bottom">
            <span class="margin-right ">
              {{ `${lineSelected.CantidadTotalCargada} ${$t('common.of')} ${lineSelected.CantidadTotalPales}` }}
            </span>
            <img :src="icPaletEscaner">
          </div>
        </div>
      </template>
    </UCCodeScanner>
    <!-- popup mostrar datos despues del escaneo de pale -->
    <PCPopupScanData
      ref="PCPopupScanData"
      @confirm="EventConfirmScanData"
    />
  </f7-page>
</template>

<script>
import { mapState } from 'pinia';
import { useAppConfigStore } from '@/js/stores/appConfig';
import { useParamRef } from '@erpagroapp/params';

import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import APIErp from '@/js/services/APIErp';
import ConexionTA from '@/js/services/traceability/APITraceability';
import {
  ConfirmDialogGH,
  HiDialog,
  HiNotification,
  PreloaderGH,
} from '@/js/common/HINotificationSupport';
import icPalet from '@/static/icons/ic_palet_2.svg';
import icPaletEscaner from '@/static/icons/ic_palet_02.svg';
import icQr from '@/static/icons/ic_qr.svg';
import { ComponentState } from '@/js/common/enum';

import CargaCorrecta from '@/static/sounds/CargaCorrecta.mp3';
import { f7 } from 'framework7-vue';
import { sleep } from '@/js/utils/sleep';
import { useSound } from '@/composables/useSound';

import TheNavbar from '@/components/TheNavbar.vue';
import UCAcordeon from '@/components/common/UCAcordeon.vue';
import UCCodeScanner from '@/components/common/UCCodeScanner.vue';
import PCPopupScanData from '@/components/production/commercialization/picking/PCPopupScanData.vue';

/** @import { InfoSheetState } from '@erpagroapp/types' */

export default {
  name: 'FrmExpeditionDocumentAddPaleNoSales',

  components: {
    UCAcordeon,
    TheNavbar,
    PCPopupScanData,
    UCCodeScanner,
  },

  props: {
    lineExpedition: {
      type: Object,
      default: null,
    },

    expedition: {
      type: Object,
      default: null,
    },

    filtradoPorNumeroSerie: {
      type: String,
      default: null,
    },
  },

  emits: ['state-change'],

  data() {
    return {
      icQr,
      icPalet,
      icPaletEscaner,
      paletsCargados: [
        {
          Estado: 'Palets cargados',
          items: [],
        },
      ],
      paletsReservados: [
        {
          Estado: 'Palets reservados a orden',
          items: [],
        },
      ],
      actionChargesOpened: false, // Controla la apertura del actión de cargas.
      actionReservationOpened: false, // Controla la apertura del actión de reservas de la orden de carga.
      actionAddTemperature: false,
      temperatura: '',
      showOptionDeleteReservation: false, // Controla si se muestra la opción de eliminar reserva
      showOptionChargeReservation: false, // Controla si se muestra la opción de cargas palés seleccionados.
      modificado: false, // es true si se modifica el array de datos inicial
      lineSelected: null,
      lecturaParaReservaActiva: false, // controla si la lectura es para reserva o para carga
      itemSelected: null, // pale seleccionado
      introduccionManualCBLecturaPalesExpeciones: useParamRef('IntroduccionManualCBLecturaPalesExpeciones'),
      lecturaContinuaCargasExpediciones: useParamRef('LecturaContinuaCargasExpediciones'),
      soundCargaCorrecta: useSound(CargaCorrecta),
      infoSheetParams: {
        opened: false,
        title: '',
        subtitle1: null,
        /** @type {InfoSheetState} */
        state: 'CAUTION',
      },
    };
  },

  computed: {
    ...mapState(useAppConfigStore, ['userEnviroment']),
    componentState() {
      return !this.modificado ? ComponentState.INITIAL : ComponentState.EDIT;
    },
    appTheme() {
      return {
        '--f7-navbar-bg-color': '#556080',
      };
    },
  },

  watch: {
    componentState(val) {
      this.$emit('state-change', val);
    },
  },
  mounted() {
    if (this.filtradoPorNumeroSerie != null) {
      this.modificado = true;
    }
  },

  created() {
    this.modificado = false;
    this.StartDocument();
  },

  methods: {

    StartDocument() {
      this.lineSelected = { ...this.lineExpedition };
      this.ProcessingDataGET();
    },
    /** Method ProcessingDataGET */
    async ProcessingDataGET() {
      Log(this, this.ProcessingDataGET.name);
      const cargados = [];
      const planificados = [];
      this.lineSelected.Desglose.forEach((e) => {
        if (e.Estado === 2) {
          cargados.push(e);
        } else if ((e.Estado === 0 || e.Estado === 1) && e.UnidadContenedora != null) { // Pendiente o EnTransito
          planificados.push(e);
        }
      });
      // Palés Cargados en otra linea
      if (this.lineSelected.RelacionesConOtrasCargas.length > 0) {
        this.lineSelected.RelacionesConOtrasCargas[0].Desglose.forEach((e) => {
          if (e.Estado === 2) {
            if (!cargados.some((x) => x.Id === e.Id)) {
              e.disabled = true;
              cargados.push(e);
            }
          } else if ((e.Estado === 0 || e.Estado === 1) && e.UnidadContenedora != null) { // Pendiente o EnTransito
            if (!planificados.some((x) => x.Id === e.Id)) {
              e.disabled = true;
              planificados.push(e);
            }
          }
        });
      }

      this.paletsCargados[0].items = cargados;
      this.paletsCargados[0].items.forEach((e) => {
        e.checked = false;
      });
      this.paletsReservados[0].items = planificados;
      this.paletsReservados[0].items.forEach((e) => {
        e.checked = false;
      });
      // Calculo de cantidades Totales
      this.paletsReservados[0].items.forEach((e) => {
        let cantidadEnvases = 0;
        let cantidadProducto = 0;
        e.UnidadContenedora.Existencias.forEach((ex) => {
          if (Number(ex.Articulo.TipoArticulo) === 1) { cantidadEnvases += Number(ex.Cantidad); }
          if (Number(ex.Articulo.TipoArticulo) === 2) { cantidadProducto += Number(ex.Cantidad); }
        });
        e.UnidadContenedora.CantidadEnvases = cantidadEnvases;
        e.UnidadContenedora.CantidadProducto = cantidadProducto;
      });
      this.paletsCargados[0].items.forEach((e) => {
        let cantidadEnvases = 0;
        let cantidadProducto = 0;
        e.UnidadContenedora.Existencias.forEach((ex) => {
          if (Number(ex.Articulo.TipoArticulo) === 1) { cantidadEnvases += Number(ex.Cantidad); }
          if (Number(ex.Articulo.TipoArticulo) === 2) { cantidadProducto += Number(ex.Cantidad); }
        });
        e.UnidadContenedora.CantidadEnvases = cantidadEnvases;
        e.UnidadContenedora.CantidadProducto = cantidadProducto;
      });
      this.lineSelected.CantidadTotalCargada = this.paletsCargados[0].items.length;
    },
    async DeleteCharge() {
      Log(this, this.DeleteCharge.name);
      this.paletsCargados[0].items.forEach(async (l) => {
        if (l.checked) {
          // this.newListaCheck.forEach(async (l) => {
          HiDialog.Preloader(true, `Eliminando carga palé ${l.UnidadContenedora.NumeroSerie}`, false);
          let result = { valor: false };
          try {
            result = await this.Conections_ChangeStatusPallet(l.UnidadContenedora.Id, l.Id, this.lineSelected.Expedicion.Id, 0);
          } catch (error) {
            LogError(this, this.DeleteCharge.name, error);
          }
          HiDialog.Preloader(false);
          if (result.valor) {
            l.EstadoCarga = 0;
            this.paletsCargados[0].items = this.paletsCargados[0].items.filter((item) => item.Id !== l.Id); // Eliminamos el cargado
            this.paletsReservados[0].items.push(l);
            this.lineSelected.CantidadTotalCargada = this.paletsCargados[0].items.length;
          } else {
            HiNotification.Alert('No es posible eliminar la carga del palé', 'Aviso');
          }
        }
      });
      this.paletsCargados[0].items.forEach((e) => {
        e.checked = false;
      });
      this.modificado = true;
    },
    async DeleteReservationSelected() {
      Log(this, this.DeleteReservationSelected.name);
      const forDeletion = [];
      for await (const e of this.paletsReservados[0].items.filter((item) => item.checked)) {
        HiDialog.Preloader(true, `Eliminando reserva palé ${e.UnidadContenedora.NumeroSerie}`, false);
        const result = await APIErp.callBorrarReservaXOrdenCargaSinPedido(e.UnidadContenedora.Id, e.Id, this.lineSelected.Expedicion.Id);
        if (result.statusText === 'OK' || result.status === 200) {
          forDeletion.push(e);
          const dl = this.lineSelected.Desglose.find((j) => j.Id === e.Id);
          dl.Estado = 0;
          dl.UnidadContenedora = null;
        }
        HiDialog.Preloader(false);
      }
      this.paletsReservados[0].items.forEach((e) => {
        e.checked = false;
      });
      this.paletsReservados[0].items = this.paletsReservados[0].items.filter((item) => !forDeletion.includes(item));
      // await this.GetReservationXLine(this.lineSelected.LineaPedidoVenta.Id);
      this.modificado = true;
    },
    async ChangeTemperaturePaletsSelectedReservados() {
      Log(this, this.ChangeTemperaturePaletsSelectedReservados.name);
      this.paletsReservados[0].items.forEach(async (l) => {
        if (l.checked) {
          // this.newListaCheck.forEach(async (l) => {
          HiDialog.Preloader(true, `Cambiando temperatura palé ${l.UnidadContenedora.NumeroSerie}`, false);
          let result = { valor: false };
          try {
            result = await this.Conections_ChangeTemperaturePale(l.UnidadContenedora.Id, l.Id, this.temperatura);
          } catch (error) {
            LogError(this, this.ChangeTemperaturePaletsSelectedReservados.name, error);
          }
          HiDialog.Preloader(false);
          if (result.valor) {
            l.TemperaturaPale = this.temperatura;
          } else {
            HiNotification.Alert('No es posible cambiar la temperatura del palé', 'Aviso');
          }
        }
      });
      this.paletsReservados[0].items.forEach((e) => {
        e.checked = false;
      });
      this.modificado = true;
    },
    async ChangeTemperaturePaletsSelectedCargados() {
      Log(this, this.ChangeTemperaturePaletsSelectedCargados.name);
      this.paletsCargados[0].items.forEach(async (l) => {
        if (l.checked) {
          // this.newListaCheck.forEach(async (l) => {
          HiDialog.Preloader(true, `Cambiando temperatura palé ${l.UnidadContenedora.NumeroSerie}`, false);
          let result = { valor: false };
          try {
            result = await this.Conections_ChangeTemperaturePale(l.UnidadContenedora.Id, l.Id, this.temperatura);
          } catch (error) {
            LogError(this, this.ChangeTemperaturePaletsSelectedCargados.name, error);
          }
          HiDialog.Preloader(false);
          if (result.valor) {
            l.TemperaturaPale = this.temperatura;
          } else {
            HiNotification.Alert('No es posible cambiar la temperatura del palé', 'Aviso');
          }
        }
      });
      this.paletsCargados[0].items.forEach((e) => {
        e.checked = false;
      });
      this.modificado = true;
    },

    ChargeSelectedPales() {
      Log(this, this.ChargeSelectedPales.name);
      this.paletsReservados[0].items.forEach((e) => {
        if (e.checked) { this.CompletePaleCharge(e, false); }
      });
      this.modificado = true;
    },
    async ChargePaleInExpedition(stringNumeroSerie, idNumeroSerie, idLineExpedition, idExpedition, mostrarPreload) {
      Log(this, this.ChargePaleInExpedition.name);
      if (!mostrarPreload) {
        HiDialog.Preloader(true, `Cargando palé ${stringNumeroSerie}`, false);
      }

      let result = { valor: false };
      try {
        result = await this.Conections_ChangeStatusPallet(idNumeroSerie, idLineExpedition, idExpedition, 2);
      } catch (error) {
        if (!mostrarPreload) {
          HiDialog.Preloader(false);
        }
        LogError(this, this.ChargePaleInExpedition.name, error);
      }
      if (!mostrarPreload) {
        HiDialog.Preloader(false);
      }
      this.modificado = true;
      return result;
    },
    async CompletePaleCharge(l, mostrarPreload) {
      Log(this, this.CompletePaleCharge.name);
      l.checked = false;
      const result = await this.ChargePaleInExpedition(l.UnidadContenedora.NumeroSerie, l.UnidadContenedora.Id, l.Id, this.lineSelected.Expedicion.Id, mostrarPreload);
      if (result.valor) {
        l.EstadoCarga = 2;
        this.paletsReservados[0].items = this.paletsReservados[0].items.filter((item) => item.Id !== l.Id);
        this.paletsCargados[0].items.push(l);
        if (!mostrarPreload) {
          this.ShowInfoPale(true, `Palé ${l.UnidadContenedora.NumeroSerie} cargado correctamente`);
        }
        this.soundCargaCorrecta.play();
      } else if (!this.lecturaContinuaCargasExpediciones) {
        await this.Conexion_GetExpedition(this.expedition);
        this.ProcessingDataGET();
        HiNotification.Alert(`No es posible cargar el palé ${l.UnidadContenedora.NumeroSerie}`, 'Aviso');
      }
      this.modificado = true;
      this.lineSelected.CantidadTotalCargada = this.paletsCargados[0].items.length;
    },

    async GoBackWithReload() {
      Log(this, this.GoBackWithReload.name);
      f7.views.main.router.navigate('/commercialisation/expedition/noSalesOrder/frmExpeditionDocumentNoSales', {
        ignoreCache: true,
        reloadPrevious: true,
        props: {
          expeditionDocument: this.lineExpedition.Expedicion,
          reload: true,
        },
      });
      await sleep(500);
      f7.views.main.router.back();
    },

    goBack() {
      Log(this, this.goBack.name);
      this.GoBackWithReload();
    },
    async GoPageInitExpedition() {
      Log(this, this.GoPageInitExpedition.name);
      // f7.views.main.router.clearPreviousHistory();
      f7.views.main.router.navigate('/commercialisation/expedition/frmExpedition/', {
        clearPreviousHistory: true,
      });
    },

    /** Method ProcessPaleReadForCharge */
    async ProcessPaleReadForCharge(value, noMostrarMenu) {
      Log(this, this.ProcessPaleReadForCharge.name);
      // Validaciones de Pale Antes de la carga
      if (!noMostrarMenu) {
        HiDialog.Preloader(true, 'Validando palé para carga...');
      }

      let responseInfoPaleForExpedition = null;
      try {
        responseInfoPaleForExpedition = await APIErp.callInfoStatusXSerialNumberForExpedition(value.Id);
        HiDialog.Preloader(false);
      } catch (error) {
        HiDialog.Preloader(false);
        if (!this.lecturaContinuaCargasExpediciones) {
          HiNotification.Alert(`Ocurrió un error al consultar la información del palé ${value.NumeroSerie} para ser cargado`);
        }

        return false;
      }

      let dataInfoPaleForExpedition = null;
      if (responseInfoPaleForExpedition != null && (responseInfoPaleForExpedition.statusText === 'OK' || responseInfoPaleForExpedition.status === 200)) dataInfoPaleForExpedition = responseInfoPaleForExpedition.data;
      else {
        if (!this.lecturaContinuaCargasExpediciones) {
          HiNotification.Alert(`No es posible obtener información del palé ${value.NumeroSerie}para ser cargado`);
        }
        return false;
      }
      // 1º - El palé indicado ya está CARGADO en otra orden de carga.
      if (dataInfoPaleForExpedition.CargadoOrdenCarga && dataInfoPaleForExpedition.OrdenCargaReserva.Id !== this.lineSelected.Expedicion.Id) {
        if (!this.lecturaContinuaCargasExpediciones) {
          HiNotification.Alert(`No es posible cargar el palé ${value.NumeroSerie}. El palé indicado ya está cargado en la orden de carga ${dataInfoPaleForExpedition.OrdenCargaReserva.Serie}/${dataInfoPaleForExpedition.OrdenCargaReserva.Numero}`, 'Información');
        }
        return false;
      }
      // 2º - El palé indicado ya está CARGADO en ESTA orden de carga
      if (dataInfoPaleForExpedition.CargadoOrdenCarga && dataInfoPaleForExpedition.OrdenCargaReserva.Id === this.lineSelected.Expedicion.Id) {
        if (!this.lecturaContinuaCargasExpediciones) {
          HiNotification.Alert(`El palé ${value.NumeroSerie} ya está cargado en esta orden de carga`, 'Información');
        }
        return false;
      }
      // 3º - El palé indicado ya esta RESERVADO en otra orden de carga.
      if (dataInfoPaleForExpedition.ReservadoOrdenCarga && dataInfoPaleForExpedition.OrdenCargaReserva.Id !== this.lineSelected.Expedicion.Id) {
        if (!this.lecturaContinuaCargasExpediciones) {
          HiNotification.Alert(`No es posible cargar el palé ${value.NumeroSerie}. El palé indicado está reservado en la orden de carga ${dataInfoPaleForExpedition.OrdenCargaReserva.Serie}/${dataInfoPaleForExpedition.OrdenCargaReserva.Numero}. Elimine la reserva a la orden de carga para continuar.`, 'Información');
        }
        return false;
      }

      // 4º - El palé esta reservado en esta OC simulamos la carga desde el front.
      if (dataInfoPaleForExpedition.ReservadoOrdenCarga && dataInfoPaleForExpedition.OrdenCargaReserva.Id === this.lineSelected.Expedicion.Id) {
        this.CompletePaleCharge(this.paletsReservados[0].items.find((e) => e.UnidadContenedora.Id === value.Id), noMostrarMenu);
        return true;
      }

      // 6º - El palé indicado NO ESTA RESERVADO NI CARGADO. ¿Quieres Cargarlo?
      if (!dataInfoPaleForExpedition.ReservadoOrdenCarga && !dataInfoPaleForExpedition.CargadoOrdenCarga) {
        if (!noMostrarMenu) {
          const actionsToPopover = f7.actions.create({
            buttons: [
              {
                text: `El palé ${value.NumeroSerie} indicado no está reservado en la orden de carga. ¿Quieres reservarlo y cargarlo?`,
                label: true,
              },
              {
                text: 'Solo Reservar',
                bold: true,
                onClick: async () => {
                  HiDialog.Preloader(true, `Reservando palé ${value.NumeroSerie}`);
                  const r = await this.PaleProcessForReservation(value);
                  HiDialog.Preloader(false);
                  if (r.Valor) {
                    this.ShowInfoPale(true, `Palé ${value.NumeroSerie} reservado correctamente`);
                  } else {
                    HiNotification.Alert(r.Mensaje, 'Información');
                  }
                },
              },
              {
                text: 'Reservar y Cargar',
                onClick: async () => {
                  await this.ReservationAndCharge(value);
                },
              },
              {
                text: 'Cancelar',
                color: 'red',
              },
            ],
          });
          actionsToPopover.open();
          return true;
        }
        return true;
      }

      await this.ReservationAndCharge(value);
      return true;
    },
    async ReservationAndCharge(unitContainerForCharge) {
      try {
        HiDialog.Preloader(true, `Reservando palé ${unitContainerForCharge.NumeroSerie}`);
        const r = await this.PaleProcessForReservation(unitContainerForCharge);
        HiDialog.Preloader(false);
        if (!r.Valor) {
          if (!this.lecturaContinuaCargasExpediciones) {
            HiNotification.Alert(r.Mensaje, 'Información');
          }
          return;
        }
        await this.ProcessPaleReadForCharge(unitContainerForCharge); // Una vez reservado llamamos con recursividad para cargarlo.
        this.modificado = true;
      } catch (error) {
        LogError(this, this.ProcessPaleReadForCharge.name, error);
      }
    },

    async PaleProcessForReservation(ansReservar) {
      Log(this, this.PaleProcessForReservation.name);
      const result = { Valor: false, Mensaje: '' };
      this.lecturaParaReservaActiva = false;

      let responseInfoPaleForExpedition = null;
      try {
        responseInfoPaleForExpedition = await APIErp.callInfoStatusXSerialNumberForExpedition(ansReservar.Id);
      } catch (error) {
        LogError(this, this.PaleProcessForReservation.name, error);
        result.Mensaje = error;
        return result;
      }
      if (responseInfoPaleForExpedition === null && responseInfoPaleForExpedition.statusText !== 'OK') {
        result.Mensaje = `No es posible obtener información del palé ${ansReservar.NumeroSerie} para ser reservado`;
        return result;
      }
      const resValidate = this.ValidatePaleForReservation(ansReservar, responseInfoPaleForExpedition.data);
      if (!resValidate.Valor) { return resValidate; }
      let resultReservation = null;
      // Obtenemos la primera linea disponible para reservar
      const lineExpeditionForReservation = this.lineSelected.Desglose.find((e) => e.Estado === 0 && e.UnidadContenedora === null);
      if (lineExpeditionForReservation === undefined) {
        HiNotification.Toast('Se ha llegado al total de la carga', 3000);
        // await this.GetReservationXLine(this.lineSelected.LineaPedidoVenta.Id);
        result.Valor = false;
        result.Mensaje = 'No es posible reservar el palé';
        return result;
      }
      try {
        resultReservation = await APIErp.callReservarPaleXOrdenCargaSinPedido(ansReservar.Id, lineExpeditionForReservation.Id, this.lineSelected.Expedicion.Id);
      } catch (error) {
        LogError(this, this.PaleProcessForReservation.name, error);
        result.Mensaje = error;
        return result;
      }
      if (resultReservation !== null && resultReservation.data.valor) {
        // await this.GetReservationXLine(this.lineSelected.LineaPedidoVenta.Id);
        const dl = this.lineSelected.Desglose.find((e) => e.Id === lineExpeditionForReservation.Id);
        dl.Estado = 1;
        dl.UnidadContenedora = ansReservar;
        this.paletsReservados[0].items.push({
          Estado: 1, Id: resultReservation.data.id, TemperaturaPale: 0, UnidadContenedora: ansReservar,
        });
        this.modificado = true;
        result.Valor = true;
        return result;
      }
      result.Valor = false;
      result.Mensaje = resultReservation.data.mensaje;
      return result;
    },
    ValidatePaleForReservation(ansReservar, dataInfoPaleForExpedition) {
      Log(this, this.ValidatePaleForReservation.name);
      // 1º - El palé indicado ya está Reservado o Cargado en ESTA
      if (dataInfoPaleForExpedition.OrdenCargaReserva?.Id === this.lineSelected.Expedicion.Id) {
        const e1 = `No es posible reservar el palé ${ansReservar.NumeroSerie}. El palé indicado ya está ${dataInfoPaleForExpedition.CargadoOrdenCarga ? 'cargado' : 'reservado'}  en esta orden de carga.`;
        // HiNotification.Alert(e1, 'Información');
        return { Valor: false, Mensaje: e1 };
      }
      // 2º - El palé indicado ya está CARGADO o Reservado en OTRA orden de carga.
      if (dataInfoPaleForExpedition.CargadoOrdenCarga && dataInfoPaleForExpedition.OrdenCargaReserva?.Id !== this.lineSelected.Expedicion.Id) {
        const e1 = `No es posible reservar el palé ${ansReservar.NumeroSerie}. El palé indicado ya está ${dataInfoPaleForExpedition.CargadoOrdenCarga ? 'cargado' : 'reservado'} en la orden de carga ${dataInfoPaleForExpedition.OrdenCargaReserva.Serie}/${dataInfoPaleForExpedition.OrdenCargaReserva.Numero}`;
        // HiNotification.Alert(e1, 'Información');
        return { Valor: false, Mensaje: e1 };
      }
      return { Valor: true };
    },

    /** ************************************************************* */
    /** ********************** EVENTOS ***************************** */
    /** ************************************************************ */

    /** Method EventOpenActionsReservation */
    EventOpenActionsReservation(valor) {
      Log(this, this.EventOpenActionsReservation.name);
      if (valor) {
        this.actionReservationOpened = true;
        if (this.paletsReservados[0].items.filter((e) => e.checked).length > 0) {
          this.showOptionDeleteReservation = true;
          this.showOptionChargeReservation = true;
        } else {
          this.actionAdd = true;
          this.showOptionDeleteReservation = false;
          this.showOptionChargeReservation = false;
        }
      } else {
        this.actionReservationOpened = false;
      }
    },
    EventOpenReadAnsForReservation() {
      Log(this, this.EventOpenReadAnsForReservation.name);
      this.lecturaParaReservaActiva = true;
      // TODO: Is this needed?
      this.$refs.UCCodeScanner.Open();
    },
    async EventOpenReadAnsForCarga() {
      Log(this, this.EventOpenReadAnsForCarga.name);
      this.lecturaParaReservaActiva = false;

      if (!this.introduccionManualCBLecturaPalesExpeciones) {
        this.$refs.UCCodeScannerNotifyAddPale.OpenAuto();
      } else {
        this.$refs.UCCodeScannerNotifyAddPale.Open();
        await sleep(200);
        this.$refs.UCCodeScannerNotifyAddPale.SetFocusOnInputElement();
      }
    },
    async EventDeleteLine() {
      Log(this, this.EventDeleteLine.name);
      const resultConfirm = await ConfirmDialogGH(`Esta acción eliminará todas las reservas y cargas de linea seleccionada de la orden de carga ${this.expedition.Serie}/${this.expedition.Numero}. ¿Quieres continuar?`, 'Eliminar linea orden de carga');
      if (!resultConfirm) return;
      HiDialog.Preloader(true, 'Eliminando linea expedición...');
      const resultSave = await this.DeleteLinesExpedition([this.lineExpedition]);
      HiDialog.Preloader(false);
      if (resultSave == null) { return; }
      // Si es la unica linea de Expedición disponible en la orden de carga volvemos al formulario inicial de ordenes de carga.
      if (this.expedition.Lineas.length === 1) {
        this.GoPageInitExpedition();
      } else {
        this.modificado = true;
        this.GoBackWithReload();
      }
    },
    async EventScannerPopupClose() {
      Log(this, this.EventScannerPopupClose.name);
      if (this.introduccionManualCBLecturaPalesExpeciones && this.lecturaContinuaCargasExpediciones) {
        await this.Conexion_GetExpedition(this.expedition, false);
        this.ProcessingDataGET();
      }
    },
    async EventScannerCamClose() {
      Log(this, this.EventScannerCamClose.name);
      await this.Conexion_GetExpedition(this.expedition, false);
      this.ProcessingDataGET();
    },
    async ShowInfoPale(correcto, mensaje, timeToDisplay = 1500) {
      this.infoSheetParams.subtitle1 = mensaje;
      if (correcto) {
        this.infoSheetParams.title = 'Información';
        this.infoSheetParams.state = 'ENTER';
      } else {
        this.infoSheetParams.title = 'Incidencia';
        this.infoSheetParams.state = 'ERROR';
      }

      this.infoSheetParams.opened = true;
      await sleep(timeToDisplay);
      this.infoSheetParams.opened = false;
    },
    async EventBarCodeReading(code) {
      Log(this, this.EventBarCodeReading.name);
      let paleLeido = null;
      if (this.lineSelected.CantidadTotalCargada >= this.lineSelected.CantidadTotalPales) {
        this.$refs.UCCodeScannerNotifyAddPale.ClosePopup();
        HiNotification.Toast('Se ha llegado al total de la carga');
      } else if (!this.lecturaContinuaCargasExpediciones) {
        this.$refs.UCCodeScannerNotifyAddPale.ClosePopup();
        HiDialog.Preloader(true, 'Validando Codigo de Barras..');
        const result = await ConexionTA.callObtenePalePorCodigoDeBarras(code, true, false);
        HiDialog.Preloader(false);
        if (result.Valor) {
          paleLeido = JSON.parse(result.Mensaje);
          let mismoProducto = false;
          paleLeido.Existencias.forEach((element) => {
            if (element.Articulo.TipoArticulo === 'Producto' && element.Articulo.Id === this.lineSelected.Producto.Id) {
              mismoProducto = true;
            }
          });
          if (mismoProducto) {
            this.$refs.PCPopupScanData.Show(paleLeido);
          } else {
            HiNotification.Toast('El producto debe ser el mismo que el de la linea de orden de carga ');
          }
        } else {
          HiNotification.Alert(result.Mensaje, 'Error');
        }
      } else {
        PreloaderGH(false);
        paleLeido = {
          Id: 0,
          CodigoBarrasPale: code,
        };
        const result = await APIErp.callReservarYCargarPaleXOrdenCarga([paleLeido], this.lineSelected.Id, this.lineSelected.Expedicion.Id, 0);
        this.ProcessResponseChargePaleDirect(result.data);
        this.lineSelected.CantidadTotalCargada = this.paletsCargados[0].items.length;
        await sleep(2000);
        this.modificado = true;
      }
    },
    /** ** Método EventNumeroSerieReading ** */
    async EventNumeroSerieReading(code) {
      Log(this, this.EventNumeroSerieReading.name);
      let paleLeido = null;
      if (this.lineSelected.CantidadTotalCargada >= this.lineSelected.CantidadTotalPales) {
        this.$refs.UCCodeScannerNotifyAddPale.ClosePopup();
        HiNotification.Toast('Se ha llegado al total de la carga');
      } else if (!this.lecturaContinuaCargasExpediciones) {
        // OPCION A- CARGAS DE PALÉS SIN LECTURA CONTINUA
        this.$refs.UCCodeScannerNotifyAddPale.ClosePopup();
        PreloaderGH(true, true, 'Validando Número de serie...', 'Validación cancelada');
        const result = await ConexionTA.callObtenePalePorNumeroDeSerie(code, true, true, false);
        PreloaderGH(false);
        if (result.Valor) {
          paleLeido = JSON.parse(result.Mensaje);
          let mismoProducto = false;
          paleLeido.Existencias.forEach((element) => {
            if (element.Articulo.TipoArticulo === 'Producto' && element.Articulo.Id === this.lineSelected.Producto.Id) {
              mismoProducto = true;
            }
          });
          if (mismoProducto) {
            this.$refs.PCPopupScanData.Show(paleLeido);
          } else {
            HiNotification.Toast('El producto debe ser el mismo que el de la linea de orden de carga ');
          }
        } else {
          HiNotification.Alert(result.Mensaje, 'Error');
        }
      } else {
        // OPCION B - CARGA DE PALÉS CON LECTURA CONTINUA
        paleLeido = {
          Id: 0,
          NumeroSerie: code,
        };
        const result = await APIErp.callReservarYCargarPaleXOrdenCarga([paleLeido], this.lineSelected.Id, this.lineSelected.Expedicion.Id, 0);
        this.ProcessResponseChargePaleDirect(result.data);
        this.lineSelected.CantidadTotalCargada = this.paletsCargados[0].items.length;
        this.modificado = true;
        await sleep(2000);
      }
    },
    /** ** Método ProcessResponseChargePaleDirect ** */
    ProcessResponseChargePaleDirect(data) {
      Log(this, this.ProcessResponseChargePaleDirect.name);
      const elementOK = data.Tag.OK;
      const elementERROR = data.Tag.ERROR;

      if (elementOK.length > 0 && elementERROR.length === 0) {
        const pales = elementOK.map((element) => element.tag.UnidadContenedora.NumeroSerie);
        const message = pales.length === 1
          ? `Palé ${pales[0]} cargado correctamente`
          : `Los Palés ${pales.join(', ')} se han cargado correctamente`;
        this.ShowInfoPale(true, message);
        this.soundCargaCorrecta.play();
        // SIMULAMOS LA CARGA DEL PALE EN EL FRONT
        elementOK.forEach((el) => {
          this.paletsCargados[0].items.push(el.tag);
        });
      } else if (elementOK.length === 0 && elementERROR.length === 1) {
        this.ShowInfoPale(false, elementERROR[0].mensaje);
      } else if (elementOK.length === 0 && elementERROR.length > 0) {
        const pales = elementERROR.map((element) => element.tag.NumeroSerie);
        const errorMessage = pales.length === 1
          ? `El Palé ${pales[0]} No se ha cargado correctamente. ${elementERROR[0].mensaje}`
          : `Los Palés ${pales.join(', ')} No se han cargado correctamente. ${elementERROR[0].mensaje}`;
        this.ShowInfoPale(false, errorMessage);
      } else if (elementOK.length > 0 && elementERROR.length > 0) {
        this.ShowInfoPale(false, `Varios palés no han sido cargados. ${elementERROR[0].mensaje}`);
      }
    },
    /** ** Método EventConfirmScanData ** */
    async EventConfirmScanData(value) {
      Log(this, this.EventConfirmScanData.name);
      if (this.lecturaParaReservaActiva === true) {
        this.PaleProcessForReservation(value);
        HiDialog.Preloader(true, `Reservando palé ${value.NumeroSerie}`);
        const r = await this.PaleProcessForReservation(value);
        HiDialog.Preloader(false);
        // await this.GetReservationXLine(this.lineSelected.LineaPedidoVenta.Id);
        if (r.Valor) {
          HiNotification.Toast(`Palé ${value.NumeroSerie} reservado correctamente`);
        } else {
          HiNotification.Alert(r.Mensaje, 'Información');
        }
        // HiNotification.Toast(`Palé ${value.NumeroSerie} reservado correctamente`);
      } else if (this.lecturaParaReservaActiva === false) {
        this.ProcessPaleReadForCharge(value, false);
      }
    },

    /** ************************************************************* */
    /** ********************** CONEXIONES ***************************** */
    /** ************************************************************ */
    async Conexion_GetExpedition(expeditionDocument, noMostrarPreload) {
      Log(this, this.Conexion_GetExpedition.name);
      if (!noMostrarPreload) {
        HiDialog.Preloader(true, 'Cargando Datos');
      }
      const result = await APIErp.callGetExpedition(expeditionDocument, [0, 1, 2], this.userEnviroment.EntornoDeTrabajo.Centro);
      this.lineSelected = { ...result.data[0].Lineas.filter((e) => e.Cliente?.Id === this.lineSelected.Cliente.Id && e.Direccion?.Id === this.lineSelected.Direccion.Id && e.Producto?.Id === this.lineSelected.Producto.Id)[0] };
      if (!noMostrarPreload) {
        HiDialog.Preloader(false);
      }
    },
    async Conections_ChangeStatusPallet(idArticuloNumeroSerie, idLineaOrdenCarga, idOrdenCarga, newState) {
      Log(this, this.Conections_ChangeStatusPallet.name);
      const res = await APIErp.callChangeStatusPale(idArticuloNumeroSerie, idLineaOrdenCarga, idOrdenCarga, newState);
      return res.data;
    },
    async Conections_ChangeTemperaturePale(idArticuloNumeroSerie, idLineaOrdenCarga, newTemperature) {
      Log(this, this.Conections_ChangeTemperaturePale.name);
      const res = await APIErp.callChangeTemperaturePale(idArticuloNumeroSerie, idLineaOrdenCarga, newTemperature);
      return res.data;
    },

    async DeleteLinesExpedition(objExpedition) {
      HiDialog.Preloader(true, 'Eliminando lineas de expedición', false);
      try {
        const result = await APIErp.callDeleteLinesExpedition(objExpedition);
        HiDialog.Preloader(false);
        return result.data;
      } catch (error) {
        HiDialog.Preloader(false);
        HiNotification.Alert(error, 'Aviso');
        return null;
      }
    },
  },
};
</script>

<style lang="scss">
.main-expedition-document-add-pale-no-sales {
  .disabled-component {
    opacity: 0.6;
    pointer-events: none;
  }

  .icon-custom-back {
    background-image: url("@/static/icons/ic_back.svg");
    width: 24px;
    height: 24px;
  }

  .content-data {
    .storybook-action-sorted-accordion .accordion-list .accordion-item-opened > .item-inner > ::after {
      border-top: 0;
    }

    &__row {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &__col {
      display: flex;
      align-items: flex-start;
      flex-direction: column;

      &--gray {
        font-size: 10px;
        font-weight: 400;
        color: var(--his-ash-gray);
        text-transform: uppercase;
      }

      &--strong-blue {
        font-size: 16px;
        font-weight: 500;
        color: var(--his-slate-blue);
      }
    }

    &__info {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      min-width: 115px;

      img {
        margin-left: 5px;
      }

      &--yellow {
        background: #fce0b1;
        margin-right: 10px;
        padding-left: 4px;
        padding-right: 5px;
      }

      &--strong-blue {
        font-size: 22px;
        margin-right: 5px;
        font-weight: 500;
        color: var(--his-slate-blue);

        span {
          font-size: 18px;
          font-weight: 400;
        }
      }
    }

    .suboption-list {
      --f7-list-media-item-padding-vertical: 12px;
      --f7-list-item-title-font-size: 14px;
      --f7-list-item-title-text-color: var(--his-slate-blue);
      --f7-list-item-title-font-weight: 500;
      --f7-list-item-subtitle-font-size: 12px;
      --f7-list-item-subtitle-text-color: var(--his-ash-gray);
      --f7-list-item-subtitle-font-weight: 400;
      --f7-list-item-after-font-size: 22px;
      --f7-list-item-after-font-weight: 500;
      --f7-list-item-after-text-color: var(--his-slate-blue);
      --f7-list-item-after-line-height: 1;
      --f7-list-chevron-icon-area: 0;
      --f7-list-media-item-padding-horizontal: 5px;

      .suboption-list__mix {
        color: burlywood;
        padding-left: 5px;
      }
    }

    .suboption-list-fondo {
      --f7-list-media-item-padding-vertical: 12px;
      --f7-list-item-title-font-size: 14px;
      --f7-list-item-title-text-color: var(--his-slate-blue);
      --f7-list-item-title-font-weight: 500;
      --f7-list-item-subtitle-font-size: 12px;
      --f7-list-item-subtitle-text-color: var(--his-ash-gray);
      --f7-list-item-subtitle-font-weight: 400;
      --f7-list-item-after-font-size: 22px;
      --f7-list-item-after-font-weight: 500;
      --f7-list-item-after-text-color: var(--his-slate-blue);
      --f7-list-item-after-line-height: 1;
      --f7-list-chevron-icon-area: 0;
      --f7-list-media-item-padding-horizontal: 5px;

      .suboption-list__mix {
        color: burlywood;
        padding-left: 5px;
      }

      .media-item {
        .item-content {
          .item-inner {
            .item-title-row {
              .item-title {
                background: var(--his-melon-light);
                border-radius: 5px;
                padding-top: 3px;
                padding-left: 3px;
              }
            }
          }
        }
      }
    }

    .content-data-state {
      .span-charge-state {
        font-size: 24px;
      }

      .span-subtitle {
        font-size: 16px;
      }
    }

    .content-charge-reserved {
      border-bottom: 1px solid #ebebed;

      .items_orden {
        font-size: 18px;
      }

      .items_palets {
        font-size: 30px;
      }

      .items_place,
      .span-title {
        font-weight: 400;
        font-size: 12px;
        color: var(--his-ash-gray);
      }
    }
  }
}

.quantityCharged {
  font-size: 22px;
  margin-right: 5px;
  font-weight: 500;
  color: var(--his-slate-blue);
  display: flex;
  justify-content: center;
}

.content-action {
  --f7-actions-label-justify-content: center;
  --f7-actions-label-text-color: var(--his-dark-blue);
  --f7-actions-label-font-size: 14px;
  --f7-actions-label-padding: 12px 16px;

  .actions-label {
    font-weight: 500;
  }

  &__buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    &--red {
      --f7-actions-button-text-color: var(--his-tomate);
      --f7-actions-grid-button-text-color: var(--his-tomate);
    }

    &--gray {
      --f7-actions-grid-button-text-color: var(--his-slate-blue);
    }
  }

  &__options {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid var(--his-silver);
    margin: 16px 16px 0;

    div {
      padding: 8px 0;
      text-transform: uppercase;
    }

    &--gray {
      color: var(--his-ash-gray);
      font-size: 14px;
    }

    &--green {
      color: #66ba33;
      font-size: 18px;
    }
  }

  .actions-button {
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 10px;
    width: 33.33333333%;
    display: block;
    color: var(--f7-actions-grid-button-text-color);
    height: auto;
    padding: 9px;
    text-transform: uppercase;
    margin-bottom: 5px;

    &--guardar {
      background: var(--his-melon);
      color: #fff;
    }

    &--cancelar {
      background: var(--his-tomate);
      margin-right: 5px;
      color: #fff;
    }
  }
}

.item-after {
  margin-left: 31em;
}

.media-list .item-link .item-title-row::before,
 li.media-item .item-link .item-title-row::before {
  right: 0;
  visibility: hidden;
}

.content-list-checkbox-item {
  --f7-list-item-padding-horizontal: 10px;
  --f7-list-item-padding-vertical: 0;

  display: flex;
  align-items: center;
  justify-content: flex-start;

  &__details {
    width: 100%;

    .item-inner {
      color: var(--his-slate-blue);
      font-size: 14px;
      font-weight: 500;
    }
  }
}

.input-temperatura {
  background: #fff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 14px 130px;
  gap: 10px;
}
</style>
